const KEY_HELPERS = 'viewed_helpers';
const KEY_JOBS = 'viewed_jobs';

function readSet(key: string): Set<number> {
  try {
    const raw = localStorage.getItem(key);
    return raw ? new Set(JSON.parse(raw)) : new Set();
  } catch { return new Set(); }
}

function writeSet(key: string, set: Set<number>): void {
  try { localStorage.setItem(key, JSON.stringify(Array.from(set))); } catch {}
}

export function markHelperViewed(id: number): void {
  const s = readSet(KEY_HELPERS);
  s.add(id);
  writeSet(KEY_HELPERS, s);
}

export function markJobViewed(id: number): void {
  const s = readSet(KEY_JOBS);
  s.add(id);
  writeSet(KEY_JOBS, s);
}

export function isHelperViewed(id: number): boolean {
  return readSet(KEY_HELPERS).has(id);
}

export function isJobViewed(id: number): boolean {
  return readSet(KEY_JOBS).has(id);
}
